import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const JobSeekerProfileUpdate = () => {
    const [formData, setFormData] = useState({
        full_name: '',
        email: '',
        phone: '',
        gender: '',
        veteran_status: '',
        work_visa_status: '',
        linkedin: '',
        portfolio: '',
        work_status: '',
        disability: '',
        resume: null, // Resume file upload
    });

    const [message, setMessage] = useState('');
    const navigate = useNavigate();
    const username = localStorage.getItem('jobseeker_username');

    useEffect(() => {
        const storedUsername = localStorage.getItem('username'); // Retrieve the username from localStorage
        if (!storedUsername) {
            setMessage('No job seeker username found. Please log in again.');
            return;
        }
    
        const fetchProfile = async () => {
            try {
                const response = await axios.get(`http://127.0.0.1:5000/jobseekers/profile?username=${storedUsername}`);
                setFormData(response.data);
            } catch (error) {
                console.error('Error fetching job seeker profile:', error);
                setMessage('Failed to fetch profile. Please try again later.');
            }
        };
    
        fetchProfile();
    }, []); // Removed `setUsername` (it wasn't needed)      

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleFileChange = (e) => {
        setFormData({ ...formData, resume: e.target.files[0] });
    };    

    const handleSubmit = async (e) => {
        e.preventDefault();

        const formDataToSend = new FormData();
        Object.keys(formData).forEach((key) => {
            formDataToSend.append(key, formData[key]);
        });

        try {
            const response = await axios.put(`http://127.0.0.1:5000/jobseekers/profile`, formDataToSend, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });

            if (response.status === 200) {
                setMessage('Profile updated successfully!');
            } else {
                setMessage('Failed to update profile.');
            }
        } catch (error) {
            console.error('Error updating profile:', error);
            setMessage('Failed to update profile. Please try again.');
        }
    };

    return (
        <div style={{ padding: '20px', maxWidth: '600px', margin: '0 auto' }}>
            <h2>Update Your Profile</h2>
            {message && <p style={{ color: 'red' }}>{message}</p>}
            <form onSubmit={handleSubmit}>
                <div style={{ marginBottom: '15px' }}>
                    <label>Full Name:</label>
                    <input
                        type="text"
                        name="full_name"
                        value={formData.full_name}
                        onChange={handleChange}
                        required
                        style={{ width: '100%', padding: '10px' }}
                    />
                </div>
                <div style={{ marginBottom: '15px' }}>
                    <label>Email:</label>
                    <input
                        type="email"
                        name="email"
                        value={formData.email}
                        disabled
                        style={{ width: '100%', padding: '10px', backgroundColor: '#f0f0f0' }}
                    />
                </div>
                <div style={{ marginBottom: '15px' }}>
                    <label>Phone:</label>
                    <input
                        type="tel"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        required
                        style={{ width: '100%', padding: '10px' }}
                    />
                </div>
                <div style={{ marginBottom: '15px' }}>
                    <label>Gender:</label>
                    <select
                        name="gender"
                        value={formData.gender}
                        onChange={handleChange}
                        required
                        style={{ width: '100%', padding: '10px' }}
                    >
                        <option value="">-- Select Gender --</option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                        <option value="Non-Binary">Non-Binary</option>
                        <option value="Prefer not to say">Prefer not to say</option>
                    </select>
                </div>
                <div style={{ marginBottom: '15px' }}>
                    <label>Veteran Status:</label>
                    <select
                        name="veteran_status"
                        value={formData.veteran_status}
                        onChange={handleChange}
                        required
                        style={{ width: '100%', padding: '10px' }}
                    >
                        <option value="">-- Select Veteran Status --</option>
                        <option value="Veteran">Veteran</option>
                        <option value="Non-Veteran">Non-Veteran</option>
                        <option value="Prefer not to say">Prefer not to say</option>
                    </select>
                </div>
                <div style={{ marginBottom: '15px' }}>
                    <label>Work Visa Status:</label>
                    <input
                        type="text"
                        name="work_visa_status"
                        value={formData.work_visa_status}
                        onChange={handleChange}
                        required
                        style={{ width: '100%', padding: '10px' }}
                    />
                </div>
                <div style={{ marginBottom: '15px' }}>
                    <label>LinkedIn Profile:</label>
                    <input
                        type="url"
                        name="linkedin"
                        value={formData.linkedin}
                        onChange={handleChange}
                        style={{ width: '100%', padding: '10px' }}
                    />
                </div>
                <div style={{ marginBottom: '15px' }}>
                    <label>Portfolio/Website:</label>
                    <input
                        type="url"
                        name="portfolio"
                        value={formData.portfolio}
                        onChange={handleChange}
                        style={{ width: '100%', padding: '10px' }}
                    />
                </div>
                <div style={{ marginBottom: '15px' }}>
                    <label>Update Resume:</label>
                    <input
                        type="file"
                        name="resume"
                        accept=".pdf,.doc,.docx"
                        onChange={handleFileChange}
                        style={{ marginTop: '5px' }}
                    />
                </div>
                <div style={{ marginBottom: '15px' }}>
                    <label>Current Work Status:</label>
                    <textarea
                        name="work_status"
                        value={formData.work_status}
                        onChange={handleChange}
                        required
                        style={{ width: '100%', padding: '10px' }}
                    />
                </div>
                <div style={{ marginBottom: '15px' }}>
                    <label>Disability (optional):</label>
                    <textarea
                        name="disability"
                        value={formData.disability}
                        onChange={handleChange}
                        style={{ width: '100%', padding: '10px' }}
                    />
                </div>
                <button
                    type="submit"
                    style={{
                        padding: '10px 20px',
                        backgroundColor: '#007BFF',
                        color: 'white',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer',
                    }}
                >
                    Update Profile
                </button>
            </form>
        </div>
    );
};

export default JobSeekerProfileUpdate;

